import * as React from 'react';
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {Grid, Typography} from "@material-ui/core";
import clsx from "clsx";
import logo from "images/logo couleur.png";
import {Locale} from "ias-lib";
import image from "images/urn_aaid_sc_US_e462e56d-a471-434e-a46e-3bb3d3d19841.png";
import {useState} from "react";
import ResetPasswordRequestForm from "views/login/ResetPasswordRequestForm";
import Parameters from 'parameters';
import {useSnackbar} from "notistack";

type Props = {}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: '#FFFFFF',
            height: '100vh'
        },
        form_part: {
            height: '100%',
            boxShadow: '2px 0 2px 1px white',
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        form: {
            height: '50%',
            width: '50%',
            textAlign: 'left',
        },
        image_part: {
            maxHeight: '100vh',
            overflow: 'hidden',
        },
        title: {
            marginTop: '22px',
            fontFamily: 'Eesti, sans-serif',
            fontSize: '36px',
            paddingBottom: '15px',
        },
    })
);
const ResetPasswordRequest: React.FunctionComponent<Props> = () => {
    const classes= useStyles();
    const {enqueueSnackbar} = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [displayEndMessage, setDisplayEndMessage] = useState(false);
    return (

        <div>
            <Grid container className={clsx(classes.root)}>
                <Grid item className={clsx(classes.form_part)} xs={6}>
                    <div className={clsx(classes.form)}>
                        <img width="162px" src={logo} alt="Logo" />
                        <Typography variant="h2" gutterBottom className={clsx(classes.title)}>
                            {Locale.trans('login.username_forgotten_title')}
                        </Typography>
                        <ResetPasswordRequestForm
                            onSubmit={async (email: string) => {
                                try {
                                setLoading(true);
                                const res = await fetch(`${
                                        Parameters.ApiUrl
                                    }reset-password-request`,
                                    {
                                        method: 'POST',
                                        headers: {
                                            Accept: 'application/json',
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            email,
                                        })
                                    },
                                );
                                if(res.ok) {
                                    enqueueSnackbar(Locale.trans('login.request_sent'), {variant: 'success'});
                                    setDisplayEndMessage(true);
                                } else {
                                    enqueueSnackbar(Locale.trans('login.request_error'), {variant: 'error'});
                                }
                                setLoading(false);
                                setDisplayEndMessage(true);
                                } catch(error) {
                                    console.error(error);
                                    setLoading(false);
                                    enqueueSnackbar(Locale.trans('error.undefined'), {variant: 'error'});
                                }
                            }}
                            loading={loading}
                        />
                        {displayEndMessage && <b>Un mail vous a été envoyé, vous pouvez désormais quitter cette page.</b> }

                    </div>
                </Grid>
                <Grid item className={clsx(classes.image_part)} xs={6}>
                    <div className="logo">
                        <img src={image} alt="Logo" height="100%" width={"100%"} />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}
export default ResetPasswordRequest;
